import React from 'react'
import CustomizeModal from '../../components/CustomizeModal'
import Months from './Months'
import { useSelector } from 'react-redux';
import { selectDateFilter, selectMonthAhead } from '../../../mainFilter/selectors';
import EngineTutorial from '../../components/messages/EngineTutorial';
import NightsList from '../../components/NightsList';
import { t } from '../../../../utilities/translator';
import abTesting from '../../../../services/abTesting';

const MonthType = ({
  selectedMonths,
  selectedDays,
  weekendsOnly,
  onMonthClick,
  onDayClick,
  onWeekendsOnlyClick,
}) => {
  const monthAhead = useSelector(selectMonthAhead) || 12;
  const filterState = useSelector(selectDateFilter);
  const { flexible } = filterState.initial;

  return (
    <>
      {!abTesting.hideDateTutorial &&
        <div className="label-large text-start font-medium">{t('tutorial.dates')}</div>
      }

      <Months
        months={flexible.months}
        monthsAhead={monthAhead}
        selected={selectedMonths}
        onMonthClick={onMonthClick}
      />

      <NightsList
        onChange={onDayClick}
        selected={selectedDays}
        weekendsOnly={weekendsOnly}
        onWeekendsChange={onWeekendsOnlyClick}
        variant="gray"
      />
    </>
  )
}

export default MonthType
